export enum SlideParallaxType {
    reveal = 'reveal',
    cover = 'cover'
}